import { graphql } from '@/generated/gql';

export const CREATE_NEGOTIATION_CASE_MUTATION = graphql(/* GraphQL */ `
  mutation CreateNegotiationCase($demandId: UUID!, $data: TsrctNegotiationCaseInput!) {
    tesseract {
      demand(id: $demandId) {
        negotiationCase {
          create(data: $data) {
            id
          }
        }
      }
    }
  }
`);
